export const COKE_THEME = "COKE_THEME";
